module.exports = __webpack_public_path__ + "img/dcmm_16.d7717657.png";